"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const __1 = require("../../..");
function FooterLogo({ children, logoDesc, logoSrc }) {
    if (logoSrc && !logoDesc) {
        throw new Error('`logoDesc` must be provided when using `logoSrc`.');
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [logoSrc && ((0, jsx_runtime_1.jsx)(__1.Grid.Col, { mobile: "auto", children: (0, jsx_runtime_1.jsx)("img", { className: "usa-footer__logo-img", src: logoSrc, alt: logoDesc }) })), (0, jsx_runtime_1.jsx)(__1.Grid.Col, { mobile: "auto", children: (0, jsx_runtime_1.jsx)("h3", { className: "usa-footer__logo-heading", children: children }) })] }));
}
exports.default = FooterLogo;
